import { render, staticRenderFns } from "./TripsList.vue?vue&type=template&id=990cc5ac&scoped=true&"
import script from "./TripsList.vue?vue&type=script&lang=js&"
export * from "./TripsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990cc5ac",
  null
  
)

export default component.exports